import { formatISO, isValid, parse, parseISO, format, lastDayOfMonth } from 'date-fns'
interface ParsedDate {
  formattedDate: string
  isoDate: string
}
interface useDateHook {
  parseFormattedDateString: (input: string) => ParsedDate
  parseISODateString: (input: string) => ParsedDate
}

export const useDate = (dateFormat: string = 'MM/YYYY'): useDateHook => {
  // Note: date-fns uses unicode tokens:
  // Ref: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
  const transformedFormat = dateFormat.replace(/D/gi, 'd').replace(/Y/gi, 'y')
  const shouldGetLastDayOfMonth = !dateFormat.includes('D')

  const parseFormattedDateString = (input: string): ParsedDate => {
    const inputDate = parse(input, transformedFormat, Date.now())
    const date = shouldGetLastDayOfMonth ? lastDayOfMonth(inputDate) : inputDate
    return {
      formattedDate: input,
      isoDate: isValid(date)
        ? formatISO(date, {
            representation: 'date',
          })
        : '',
    }
  }

  const parseISODateString = (input: string): ParsedDate => {
    const date = parseISO(input)
    return {
      formattedDate: isValid(date) ? format(date, transformedFormat) : '',
      isoDate: input,
    }
  }

  return { parseFormattedDateString, parseISODateString }
}
